import { gql } from 'graphql-request';
import type { Fields } from '@/pages/Home';
import { contentfulQuery } from '@/utilities/contentful';

export type PrivacyPolicyFields = Pick<
  Fields,
  'id' | 'title' | 'subtitle' | 'longContentOne'
>;
interface QueryResponse {
  swsAboutPageSectionsCollection: {
    items: PrivacyPolicyFields[];
  };
}

type FieldNames = 'privacy-policy';

export const queryKey = ['PRIVACY_POLICY_CONTENT'];

export async function getPrivacyPolicy() {
  const query = gql`
    query getPrivacyPolicy {
      swsAboutPageSectionsCollection(where: { id_in: ["privacy-policy"] }) {
        items {
          id
          title
          subtitle
          longContentOne
        }
      }
    }
  `;

  const contentfulData = await contentfulQuery<QueryResponse>(query);

  const data = contentfulData?.swsAboutPageSectionsCollection.items.reduce(
    (obj, item) => {
      return {
        ...obj,
        [item.id]: item,
      };
    },
    {}
  ) as Record<FieldNames, PrivacyPolicyFields>;

  return data;
}
